import { IOption } from 'libs/shared/ui/src/lib/components/dropdown/dropdown.component';
import {
  models,
  modelTypeOptions,
} from 'libs/model/src/lib/components/teleconnections/teleconnections.constants';
import {
  ITeleconnectionWidgetConfig,
  TeleconnectionWidgetView,
} from './widget-types';

export const TELECONNECTION_WIDGET_DESCRIPTION =
  'Visualize and monitor the latest weather model forecasts for the key Teleconnection indices alongside observations';

// Observation history the widget offers in its header, in days.
export const TELECONNECTION_WIDGET_RANGES = [7, 30] as const;

// Model Comparison first, ECMWF when a single model is needed, 30 days of observations.
export const DEFAULT_TELECONNECTION_WIDGET_CONFIG: ITeleconnectionWidgetConfig =
  {
    teleconnectionId: '',
    view: 'modelComparison',
    model: models[0],
    modelType: 'ENS',
    range: TELECONNECTION_WIDGET_RANGES[1],
  };

// Same labels as the page's sub-tab chips (translation keys).
export const TELECONNECTION_WIDGET_VIEW_OPTIONS: (IOption & {
  value: TeleconnectionWidgetView;
})[] = [
  { labelKey: 'modelComparison', value: 'modelComparison', isPermitted: true },
  { labelKey: 'individualView', value: 'individual', isPermitted: true },
  { labelKey: 'trends', value: 'trends', isPermitted: true },
];

export const TELECONNECTION_WIDGET_MODEL_OPTIONS: IOption[] = models.map(
  (model) => ({ labelKey: model, value: model, isPermitted: true })
);

export const TELECONNECTION_WIDGET_MODEL_TYPE_OPTIONS: IOption[] =
  modelTypeOptions.map(({ label, key }) => ({
    labelKey: label,
    value: key,
    isPermitted: true,
  }));

export const TELECONNECTION_WIDGET_RANGE_OPTIONS: IOption[] =
  TELECONNECTION_WIDGET_RANGES.map((days) => ({
    labelKey: `${days} Days`,
    value: `${days}`,
    isPermitted: true,
  }));

// Index names are shortened in the widget header; the full name stays in its tooltip.
export const TELECONNECTION_NAME_ABBREVIATIONS: [RegExp, string][] = [
  [/\bNorth America\b/gi, 'NA'],
  [/\bEurope\b/gi, 'EU'],
  [/\bDemandex\b/gi, 'DMDX'],
];

export const TELECONNECTION_WIDGET_GRID_SIZE = { h: 30, w: 8 };
